.scene {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: var(--color-scene);
}

.grid {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

.dot {
  fill: var(--color-grid-dot);
}

.modeLabel {
  position: absolute;
  top: var(--spacing-md);
  left: var(--spacing-md);
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-sm);
  padding: var(--spacing-xs) var(--spacing-md);
  border: 1px solid var(--color-border);
  border-radius: 999px;
  background: var(--color-surface);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  color: var(--color-text-muted);
  box-shadow: var(--shadow-sm);
}

.empty {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 320px;
  padding: var(--spacing-lg) var(--spacing-xl);
  border: 1px dashed var(--color-border-strong);
  border-radius: var(--radius-lg);
  background: var(--color-surface);
  text-align: center;
  pointer-events: none;
}

.emptyTitle {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
}

.emptyDescription {
  margin-top: var(--spacing-xs);
  color: var(--color-text-muted);
}

.zoomControls {
  position: absolute;
  bottom: var(--spacing-md);
  right: var(--spacing-md);
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 3px 4px;
  background: rgba(18, 24, 38, 0.88);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: var(--radius-md, 8px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.45);
  z-index: 10;
  user-select: none;
}

.zoomBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  border-radius: var(--radius-sm, 4px);
  background: transparent;
  color: var(--color-text-secondary, #94a3b8);
  cursor: pointer;
  transition: all 0.15s ease;
}

.zoomBtn:hover {
  background: rgba(255, 255, 255, 0.12);
  color: var(--color-text, #ffffff);
}

.zoomBtn:active {
  transform: scale(0.93);
}

.zoomResetBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  height: 28px;
  padding: 0 6px;
  border: none;
  border-radius: var(--radius-sm, 4px);
  background: transparent;
  color: var(--color-text-secondary, #94a3b8);
  font-size: 11px;
  font-weight: 600;
  font-family: var(--font-mono, monospace);
  cursor: pointer;
  transition: all 0.15s ease;
}

.zoomResetBtn:hover {
  background: rgba(255, 255, 255, 0.12);
  color: var(--color-text, #ffffff);
}

.zoomDivider {
  width: 1px;
  height: 16px;
  background: rgba(255, 255, 255, 0.15);
  margin: 0 2px;
}

